/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SignatureSocialPlatform } from './signatureSocialPlatform';

export interface SignatureSocial {
  platform: SignatureSocialPlatform;
  /** @maxLength 2000 */
  url: string;
}
